import React from 'react';
import styled from 'styled-components';

const GenericCrudPageContainer = styled.div`
    padding-top: 16px;    

    .main-table {
        margin-top: 10px;
    }
    
    .codebook-helptip {
        margin-left: 5px;
    }
`;

export default GenericCrudPageContainer;